import { createRootRouteWithContext, Outlet, redirect } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import type { Auth } from '../lib/auth'

export interface RouterContext {
  auth: Auth
  queryClient: QueryClient
}

// First-run gate (DIS-12): until the first user exists, every route sends
// you to /setup; once set up, /setup sends you away.
export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: async ({ context, location }) => {
    const needed = await context.auth.setupNeeded()
    const onSetup = location.pathname === '/setup'
    if (needed && !onSetup) throw redirect({ to: '/setup' })
    if (!needed && onSetup) throw redirect({ to: '/' })
  },
  component: () => <Outlet />,
  notFoundComponent: () => (
    <div className="flex h-full items-center justify-center text-fg-muted">
      <p>Not found.</p>
    </div>
  ),
})
